<template>
  <div class="container mt-5">
    <h1 class="sect-title">{{ isEditing ? 'Editar Crônica' : 'Criar Crônica' }}</h1>

    <form @submit.prevent="saveChronicle">
      <div class="mb-3">
        <label for="title" class="form-label">Título</label>
        <input type="text" class="form-control" id="title" v-model="form.title" required>
      </div>
      <div class="mb-3">
        <label for="synopsis" class="form-label">Sinopse</label>
        <textarea class="form-control" id="synopsis" v-model="form.synopsis" rows="3"></textarea>
      </div>
      <div class="mb-3">
        <label for="cover_image_path" class="form-label">URL da Imagem de Capa</label>
        <input type="text" class="form-control" id="cover_image_path" v-model="form.cover_image_path">
      </div>
      <div class="mb-3">
          <label for="tags" class="form-label">Tags (separadas por vírgula)</label>
          <input type="text" class="form-control" id="tags" v-model="form.tags">
      </div>
      <div class="row">
        <div class="col-md-6 mb-3">
          <label for="city" class="form-label">Cidade</label>
          <input type="text" class="form-control" id="city" v-model="form.city">
        </div>
        <div class="col-md-6 mb-3">
          <label for="era" class="form-label">Era</label>
          <input type="text" class="form-control" id="era" v-model="form.era">
        </div>
      </div>
       <div class="row">
        <div class="col-md-6 mb-3">
            <label for="system" class="form-label">Sistema</label>
            <input type="text" class="form-control" id="system" v-model="form.system">
        </div>
        <div class="col-md-6 mb-3">
            <label for="status" class="form-label">Status</label>
            <select class="form-control" id="status" v-model="form.status">
                <option value="in_progress">Em Andamento</option>
                <option value="finished">Finalizada</option>
            </select>
        </div>
       </div>


      <button type="submit" class="btn btn-vampire" :disabled="isSaving">
        <span v-if="isSaving" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        {{ isSaving ? 'Salvando...' : 'Salvar Crônica' }}
      </button>
      <button type="button" class="btn btn-outline-light ms-2" @click="goToChroniclesList">
        Cancelar
      </button>
    </form>

    <ChapterManager :chapters="form.chapters" @update:chapters="value => form.chapters = value" />
  </div>
</template>

<script>
import api from '../services/api';
import ChapterManager from './ChapterManager.vue';

export default {
  name: 'ChronicleCreateEditView',
  props: {
    currentUser: {
      type: Object,
      default: null,
    },
  },
  components: {
    ChapterManager,
  },
  data() {
    return {
      form: {
        title: '',
        synopsis: '',
        cover_image_path: '',
        tags: '',
        city: '',
        era: '',
        system: '',
        status: 'in_progress',
        chapters: [],
      },
      isSaving: false,
      isEditing: false,
    };
  },
  async created() {
    if (this.$route.params.id) {
      this.isEditing = true;
      await this.fetchChronicleData();
    }
  },
  methods: {
    async fetchChronicleData() {
      try {
        const { data } = await api.get(`/chronicles/${this.$route.params.id}`);
        this.form = data;
      } catch (error) {
        console.error('Failed to fetch chronicle data for editing:', error);
      }
    },
    async saveChronicle() {
      this.isSaving = true;
      try {
        if (this.isEditing) {
          await api.put(`/chronicles/${this.$route.params.id}`, this.form);
        } else {
          if (!this.currentUser || !this.currentUser.id) {
            this.isSaving = false;
            return;
          }
          await api.post('/chronicles', { ...this.form, user_id: this.currentUser.id });
        }
        this.$router.push('/cronicas');
      } catch (error) {
        console.error('Failed to save chronicle:', error);
      } finally {
        this.isSaving = false;
      }
    },
    goToChroniclesList() {
      this.$router.push('/cronicas');
    }
  },
};
</script>

<style scoped>
.form-control {
    background-color: var(--vampire-gray);
    border-color: var(--vampire-red);
    color: #f8f9fa;
}
</style>
